export const GOOGLE_MAPS_JAVASCRIPT_API =
  'AIzaSyBZxUZnoHWwXJd0dbS7MieOTXcyFkHeG4g'
export const GOOGLE_MAPS_GEOCODING_API =
  'AIzaSyDtM4zd6ewx2KFTJmPdSWICQsHtuX5sMGc'
// OBS: Não deu certo colocar essa variável acima no src/configuracoes.json do front através da pipeline (na verdade inseriu, porém só não funcionou em PRODUÇÃO. Não consegui entender o motivo)
